export const AUTO_SPEECH = 'auto-speech';
export const AUTO_SPEECH_DEFAULT = false;

export const SHOW_TRANSCRIPTION = 'show-transcription';
export const SHOW_TRANSCRIPTION_DEFAULT = false;
